import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex p-3 bg-language d-flex flex-column gap-24px" };
const _hoisted_2 = { class: "d-flex flex-column gap-8px" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 1,
    style: { "min-width": "175px" }
};
const _hoisted_5 = {
    style: { "font-size": "13px" },
    class: "d-flex flex-column align-items-center"
};
const _hoisted_6 = { class: "text-start" };
const _hoisted_7 = { class: "mb-0 text-muted small" };
const _hoisted_8 = { class: "mb-0 text-muted small" };
import axios from 'axios';
import { ref, watch, computed, onMounted } from 'vue';
import ButtonComponent from './Button.vue';
import Multiselect from 'vue-multiselect';
import DeleteModal from './DeleteModal.vue';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { openModal, closeModal } from "jenesius-vue-modal";
const text = "Stai per <u><b>rimuovere</b></u> un itinerario al momento visibile sull'app di Musei Italiani. Se procedi l'itinerario verrà eliminato e tutti i suoi dati andranno persi.<br/>Vuoi procedere?";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Language',
    props: {
        uuid: {
            type: String
        },
        itineraryTypesData: {
            type: Array
        },
        selectedTypesData: {
            type: Array
        },
        languageJson: {
            type: Array
        },
        token: {
            type: String
        },
        baseUrl: {
            type: String
        },
        status: {
            type: String
        },
        updatedBy: {
            type: String
        },
        updatedAt: {
            type: String
        }
    },
    emits: ['handleModal', 'handleLang', 'handleLabel'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const selectedLan = ref('Italiano');
        const optionArray = ref(['Italiano', 'English']);
        const labelData = ref(props.itineraryTypesData);
        const selectedLabelData = ref([]);
        const handleDelete = async () => {
            try {
                await axios
                    .delete(`${props.baseUrl}/v1/private/itineraries/${props.uuid}`, {
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                emit('handleModal');
            }
            catch (error) {
                console.log(error);
            }
            finally {
                closeModal();
            }
        };
        const onModal = async () => {
            const modal = await openModal(DeleteModal, {
                modalTitle: 'Rimozione itinerario',
                modalContent: text
            });
            modal.on('ModalConfirm', () => {
                handleDelete();
            });
        };
        const isRtl = computed(() => {
            const langObj = props.languageJson.find(el => el.name === selectedLan.value);
            return langObj.is_rtl;
        });
        watch(selectedLan, newValue => {
            /*      const direction = isRtl.value ? 'rtl' : 'ltr';
                    document.querySelectorAll('input, textarea').forEach(input => {
                    input.dir = direction;
                });
             */
            emit('handleLang', newValue);
        });
        watch(() => props.itineraryTypesData, newValue => {
            labelData.value = newValue;
        });
        watch(() => props.selectedTypesData, newValue => {
            selectedLabelData.value = newValue;
        });
        watch(() => props.languageJson, newValue => {
            optionArray.value = newValue.map(item => item.name);
        });
        onMounted(() => {
            optionArray.value = props.languageJson.map(item => item.name);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "language-title" }, " Seleziona lingua ", -1)),
                    _createVNode(_unref(Multiselect), {
                        searchable: false,
                        "show-labels": false,
                        "allow-empty": false,
                        modelValue: selectedLan.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedLan).value = $event)),
                        options: optionArray.value,
                        hideSelected: true
                    }, null, 8, ["modelValue", "options"])
                ]),
                (__props.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (__props.status === 'draft')
                            ? (_openBlock(), _createBlock(ButtonComponent, {
                                key: 0,
                                text: "Elimina elemento",
                                type: "remove",
                                onHandleClick: onModal
                            }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _cache[2] || (_cache[2] = _createElementVNode("h6", { class: "language-title" }, "Ultima modifica:", -1)),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("p", _hoisted_7, _toDisplayString(__props.updatedBy) + " Nome utente", 1),
                                        _createElementVNode("p", _hoisted_8, _toDisplayString(__props.updatedAt) + "Data ultima modifica", 1)
                                    ])
                                ])
                            ]))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
